import { render, staticRenderFns } from "./NoticeView.vue?vue&type=template&id=fda3adc2&"
import script from "./NoticeView.vue?vue&type=script&lang=js&"
export * from "./NoticeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports